/* @ts-ignore */
import { PostHogProvider } from "posthog-js/react";
import React, { useEffect } from "react";
import { useState } from "react";
var TrackingContext = function (_a) {
    var children = _a.children;
    var _b = useState(null), posthogInstance = _b[0], setPosthogInstance = _b[1];
    useEffect(function () {
        var _a;
        if ((_a = window.posthog) === null || _a === void 0 ? void 0 : _a.config) {
            setPosthogInstance(window.posthog);
        }
    }, []);
    return (React.createElement(PostHogProvider, { client: posthogInstance }, children));
};
export default TrackingContext;
